import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { AnimationHomepageSearchToggle } from '@uxdf/direct-shared-lib';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getPermissionState } from '../../../../redux/reducers';
import { PermissionConfigList } from '../../../../redux/services/utils/permission-helper.service';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss'],
  animations: [AnimationHomepageSearchToggle]
})
export class HeaderSearchComponent implements OnInit, OnDestroy {
  @Input() public opened = false;
  @Output() public closed = new EventEmitter<void>();
  public searchForm: UntypedFormGroup;
  public showSearchPanel = false;
  public category = [];
  private readonly subscriptions: Subscription;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly permissionsService: NgxPermissionsService,
    private readonly store: Store<any>
  ) {
    this.subscriptions = new Subscription();
  }

  ngOnInit() {
    this.searchForm = this.formBuilder.group({ type: [''], search: [''] });
    this.initCategories();
    this.updateFromRouter();
  }

  public onKeyup(event): void {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  public search(): void {
    const params = this.searchForm.value;
    this.router
      .navigate(['/' + params.type.id + '/search'], {
        queryParams: {
          request: params.search
        }
      })
      .then(() => {
        this.searchForm.controls['search'].setValue('');
      });
  }

  public close(): void {
    this.closed.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private initCategories() {
    this.subscriptions.add(
      this.store.pipe(select(getPermissionState)).subscribe(response => {
        if (!response.isLoading) {
          Promise.all([
            this.permissionsService.hasPermission(PermissionConfigList.CONFIG_NEWS_ENABLED),
            this.permissionsService.hasPermission(PermissionConfigList.CONFIG_CATALOG_ENABLED)
          ]).then((resolve: [boolean, boolean]) => {
            if (resolve[0]) {
              this.category.push({
                id: 'news',
                title: $localize`:@@header-search.commonSearchNews:News`
              });
            }
            if (resolve[1]) {
              this.category.push({
                id: 'store',
                title: $localize`:@@header-search.commonSearchCatalogue:Store`
              });
            }
            if (this.category.length > 0) {
              this.searchForm.controls['type'].setValue(this.category[0]);
            }
          });
        }
      })
    );
  }

  private updateFromRouter() {
    this.subscriptions.add(
      this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => {
        const activeCategory = this.category.find(v => this.router.isActive(`/${v.id}`, false));
        const value = activeCategory ? activeCategory : this.category[0];
        this.searchForm.controls['type'].setValue(value);
      })
    );
  }
}
